import React from 'react';
import { InternalGrid, PlusIcon, Text } from '@paygreen/paygreen-ui';
import { Link } from 'react-router-dom';
import { Trans } from 'react-i18next';
import CardStyled from './styled';

const EmptyProject = () => {
    return (
        <Link to="/projects">
            <CardStyled
                colorPallet="wab"
                colorWab="white20"
                hasDashedBorder
                blockWidth="md"
                paddingTop="sm"
                paddingBottom="sm"
                paddingLateral="sm"
                radiusSize="lg"
                shadowSize="none"
                htmlTag="button"
                colorTheme="secondary"
            >
                <InternalGrid childrenMarginBottom="md" justifyContent="center">
                    <PlusIcon
                        hasBackground={true}
                        isActive={true}
                        iconSize="lg"
                        colorPallet="theme"
                        colorTheme="secondary"
                    />
                    <Text textSize="sm">
                        <Trans
                            i18nKey="contributions.globalView.globalCard.emptyCardMessage"
                            components={{ bold: <strong />, italic: <i /> }}
                        />
                    </Text>
                </InternalGrid>
            </CardStyled>
        </Link>
    );
};

export default EmptyProject;
